<template>
    <h1>Atendimento Innovare TI</h1>
</template>

<script>
    // import LineChart from './Charts/LineChart.js'
    export default {
        data() {
            return {}
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue